import React from 'react';
import styled from 'styled-components';
import { assertCondition } from '../../utils/types';
import SvgIcon from './SvgIcon';
import IconWrapper from './IconWrapper';
import { IconName } from './types';
import { theme } from '../../styles/theme';

/**
 * Use this component when you need an SVG icon with a single following letter
 */

interface IProps {
  name: IconName;
  letter: string;
  isActive: boolean;
  letterXPosition?: number; // Some letters have to be adjusted for better view
}

const IconLetter = styled.span<{ $letterXPosition?: number }>`
  position: absolute;
  right: ${({ $letterXPosition }) => $letterXPosition || -4}px;
  bottom: 7px;
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  line-height: 0;
  color: ${theme.colors.mainBlue};
`;

const LetterIcon = ({ name, letter, letterXPosition, isActive }: IProps) => {
  assertCondition(letter.length === 1);

  return (
    <IconWrapper>
      <SvgIcon name={name} width={16} height={16} isActive={isActive} />
      <IconLetter $letterXPosition={letterXPosition}>{letter}</IconLetter>
    </IconWrapper>
  );
};

export default LetterIcon;
